import FUNNEL_ACTIVE from '../assets/images/funnel-active.png';
import PAGE_ACTIVE from '../assets/images/page-active.png';

import type { IPlanInfoAdditional } from '../types';

import { IPlanKey } from '../types';

export const PLAN_PRIORITY: IPlanKey[] = [
  IPlanKey.PAGE_OPT,
  IPlanKey.FUNNEL_OPT,
  IPlanKey.PROFIT_OPT,
];

export const PLAN_INFO_ADDITIONAL: Record<IPlanKey, IPlanInfoAdditional> = {
  [IPlanKey.CONTENT_TESTING]: {
    thumbnail: PAGE_ACTIVE,
  },
  [IPlanKey.PAGE_OPT]: {
    thumbnail: PAGE_ACTIVE,
  },
  [IPlanKey.FUNNEL_OPT]: {
    thumbnail: FUNNEL_ACTIVE,
  },
  [IPlanKey.PROFIT_OPT]: {
    thumbnail: FUNNEL_ACTIVE,
  },
  [IPlanKey.TRIAL_PAGE_OPT]: {
    thumbnail: PAGE_ACTIVE,
  },
  [IPlanKey.TRIAL_FUNNEL_OPT]: {
    thumbnail: FUNNEL_ACTIVE,
  },
  [IPlanKey.TRIAL_PROFIT_OPT]: {
    thumbnail: FUNNEL_ACTIVE,
  },
};

/**
 * @deprecated
 */
export const CURRENT_PLAN_SUPPORTED_CONFIG: Record<
  IPlanKey,
  { trialSupportedUpgradePlans: IPlanKey[] }
> = {
  [IPlanKey.PAGE_OPT]: {
    trialSupportedUpgradePlans: [IPlanKey.FUNNEL_OPT],
  },
  [IPlanKey.CONTENT_TESTING]: {
    trialSupportedUpgradePlans: [],
  },
  [IPlanKey.FUNNEL_OPT]: {
    trialSupportedUpgradePlans: [],
  },
  [IPlanKey.TRIAL_PAGE_OPT]: {
    trialSupportedUpgradePlans: [],
  },
  [IPlanKey.TRIAL_FUNNEL_OPT]: {
    trialSupportedUpgradePlans: [],
  },
  [IPlanKey.TRIAL_PROFIT_OPT]: {
    trialSupportedUpgradePlans: [],
  },
  [IPlanKey.PROFIT_OPT]: {
    trialSupportedUpgradePlans: [],
  },
};
